import { createSlice } from "@reduxjs/toolkit";

const bookingsInits = {
  adminBookings: [],
  myBookings: [],
  paymentList: [],
  adminPayments: [],
  hostRequests: [],
};

const reducers = {
  getUserPaymentsList: (state, action) => {
    const newItems = action.payload.items;

    state.paymentList = newItems;
  },
  getAdminPaymentsList: (state, action) => {
    state.adminPayments = action.payload.items || [];
  },
  getUserBookingsList: (state, action) => {
    const newItems = action.payload.items;

    state.myBookings = newItems;
  },
  delteUserBookingItem: (state, action) => {
    const tempMySpots = [...state.myBookings];
    const itemId = action.payload.id;

    const updatedLlist = tempMySpots.filter((item) => item.id !== itemId);

    state.myBookings = updatedLlist;
  },
  updateUserBookingItem: (state, action) => {
    const fresh = action.payload.item;
    if (!fresh || !fresh.id) return;
    state.myBookings = state.myBookings.map((b) =>
      b.id === fresh.id ? { ...b, ...fresh } : b,
    );
  },
  getAdminBookingsList: (state, action) => {
    const newItems = action.payload.items;

    state.adminBookings = newItems;
  },
  delteAdminBookingItem: (state, action) => {
    const tempItems = [...state.adminBookings];
    const itemId = action.payload.id;

    const updatedLlist = tempItems.filter((item) => item.id !== itemId);

    state.adminBookings = updatedLlist;
  },
  updateAdminBookingItem: (state, action) => {
    const fresh = action.payload.item;
    if (!fresh || !fresh.id) return;
    state.adminBookings = state.adminBookings.map((b) =>
      b.id === fresh.id ? { ...b, ...fresh } : b,
    );
  },
  getHostRequests: (state, action) => {
    const items = action.payload.items || [];
    state.hostRequests = action.payload.append
      ? [...state.hostRequests, ...items]
      : items;
  },
  removeHostRequest: (state, action) => {
    state.hostRequests = state.hostRequests.filter(
      (item) => item.id !== action.payload.id,
    );
  },
};

const bookingsSlice = createSlice({
  name: "bookings",
  initialState: bookingsInits,
  reducers,
});

export const {
  getUserBookingsList,
  delteUserBookingItem,
  updateUserBookingItem,
  getAdminBookingsList,
  delteAdminBookingItem,
  updateAdminBookingItem,
  getUserPaymentsList,
  getAdminPaymentsList,
  getHostRequests,
  removeHostRequest,
} = bookingsSlice.actions;

export default bookingsSlice.reducer;
